import { ROOT_ADMIN, ROOT_EMPLOYEE } from "../constants/HelperConstants";
import {
  PAY_PUP_ADMIN_EMAIL,
  PAY_PUP_LS_AUTH_TOKEN,
  PAY_PUP_LS_AUTH_USER_DETAILS,
  PAY_PUP_LS_AUTH_USER_ID,
  PAY_PUP_LS_AUTH_USER_ROLE,
  PAY_PUP_LS_AGENCY_ID,
  PAY_PUP_AGENCY_URL,
  PAY_PUP_IS_ROOTUSER,
} from "../constants/LocalStorageVariables";
import API from "../redux/actions/API";
import CustomButtonLoader from "./CustomComponents/CustomButtonLoader";
import { CustomAlertMessage } from "../functions/CustomFunctions";
import { useSnackbar } from "notistack";
import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Button,
  Form,
  FormGroup,
  FormFeedback,
  Label,
  Input,
  InputGroup,
  InputGroupText,
} from "reactstrap";
import {
  ADMIN_DASHBOARD_ROUTE,
  AGENCY_DASHBOARD_ROUTE,
  FORGET_PASSWORD,
  SIGNIN_AUTH_ROUTE,
} from "../constants/RoutePaths";
import loginBg from "../images/loginbg.svg";
import logo from "../images/logo.png";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { AUTH_USER_DETAILS_SUCCESS } from "../redux/actions/ActionTypes";
import { ALL_AGENCY_LIST, LOGIN_URL } from "../constants/ApiPaths";
import Iconawesomeeye from "../images/Iconawesomeeye.svg";
import Iconionicmdeyeoff from "../images/Iconionicmdeyeoff.svg";
import ResetPassword from "./ResetPassword";
import { locationParams } from "../functions/Helper";
import BackArrow from "../images/back arrow.svg";
export default function Signin() {
  const [loading, setLoading] = useState(false);
  const [loadingAuth, setLoadingAuth] = useState(false);
  const [loadingVerify, setLoadingVerify] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isAgency, setIsAgency] = useState(false);
  const history = useNavigate();
  const location = useLocation();
  const { enqueueSnackbar } = useSnackbar();
  const [authFlag, setAuthFlag] = useState(false);
  const role=''
  const [PassFlag, setPassFlag] = useState(true);
  const [UserData, setUserData] = useState([]);
  const dispatch = useDispatch();
  const [token, settoken] = useState("");
  const [passwordShown, setPasswordShown] = useState(false);
  const [list, setList] = useState([]);
  // toogle paswword icon
  const togglePassword = () => {
    setPasswordShown(passwordShown ? false : true);
  };
  const filter = locationParams(location.search);
  const rootPath = window.location.origin;
  //Sign In
  const logSig = async () => {
    if (values.agencyId === "") {
      CustomAlertMessage("Please select your agency", "error", enqueueSnackbar);
    } else {
      const config = {
        method: "POST",
        url: LOGIN_URL,
        data: {
          ...values,
          userRole: role,
          agencyId: values.agencyId,
          isAdminLogin: false,
          isFirstLogin: false,
        },
      };
      try {
        setLoadingAuth(true);

        const response = await API(config);
        const { status, data } = response.data;
        const { accesstoken } = response.headers;
        const {
          firstName,
          email,
          lastName,
          agencyId,
          isDefaultPassword,
          userId,
          roleName,
          agencyUrl,
          isRootUser,
        } = data;
        if (status === "Success") {
          localStorage.setItem(PAY_PUP_ADMIN_EMAIL, email);
          localStorage.setItem(PAY_PUP_LS_AUTH_USER_ROLE, roleName);
          localStorage.setItem(
            PAY_PUP_LS_AUTH_USER_DETAILS,
            JSON.stringify(data)
          );
          settoken(accesstoken);
          setUserData(data);
          if (isDefaultPassword) {
            setPassFlag(false);
          } else {
            dispatch({
              type: AUTH_USER_DETAILS_SUCCESS,
              payload: data,
            });
            CustomAlertMessage(
              "Logged in. Welcome " + firstName + ` ` + lastName,
              "success",
              enqueueSnackbar
            );
            localStorage.setItem(PAY_PUP_LS_AUTH_TOKEN, accesstoken);
            localStorage.setItem(PAY_PUP_LS_AUTH_USER_ID, userId);
            localStorage.setItem(PAY_PUP_LS_AGENCY_ID, agencyId);
            localStorage.setItem(PAY_PUP_IS_ROOTUSER, isRootUser);
            localStorage.setItem(PAY_PUP_AGENCY_URL, agencyUrl);
            const Root = [ROOT_ADMIN, ROOT_EMPLOYEE].includes(roleName);
           
            if (filter.ref) {
              history(filter.ref.replace(rootPath, ""));
            } else if (Root) {
              // history(ADMIN_DASHBOARD_ROUTE);
            } else {
              history(AGENCY_DASHBOARD_ROUTE);
            }
          }
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoadingAuth(false);
      }
    }
  };
  const LogIn = async (values) => {
    setLoading(true);

    const config = {
      method: "POST",
      url: LOGIN_URL,
      data: {
        ...values,
        userRole: role,
        isAdminLogin: true,
        isFirstLogin: false,
      },
    };
    try {
      const response = await API(config);
      const { status, data } = response.data;
      const { accesstoken } = response.headers;
      const {
        firstName,
        email,
        lastName,
        agencyId,
        isDefaultPassword,
        userId,
        roleName,
        agencyUrl,
        isRootUser,
      } = data;
      if (status === "Success") {
        localStorage.setItem(PAY_PUP_ADMIN_EMAIL, email);
        localStorage.setItem(PAY_PUP_LS_AUTH_USER_ROLE, roleName);
        localStorage.setItem(
          PAY_PUP_LS_AUTH_USER_DETAILS,
          JSON.stringify(data)
        );
        settoken(accesstoken);
        setUserData(data);
        if (isDefaultPassword) {
          setPassFlag(false);
        } else {
          dispatch({
            type: AUTH_USER_DETAILS_SUCCESS,
            payload: data,
          });
          history(SIGNIN_AUTH_ROUTE);

          CustomAlertMessage(
            "Logged in. Welcome " + firstName + ` ` + lastName,
            "success",
            enqueueSnackbar
          );
          localStorage.setItem(PAY_PUP_LS_AUTH_TOKEN, accesstoken);
          localStorage.setItem(PAY_PUP_LS_AUTH_USER_ID, userId);
          localStorage.setItem(PAY_PUP_LS_AGENCY_ID, agencyId);
          localStorage.setItem(PAY_PUP_IS_ROOTUSER, isRootUser);
          localStorage.setItem(PAY_PUP_AGENCY_URL, agencyUrl);
          const Root = [ROOT_ADMIN, ROOT_EMPLOYEE].includes(roleName);

          if (filter.ref) {
            history(filter.ref.replace(rootPath, ""));
          } else if (Root) {
            history(ADMIN_DASHBOARD_ROUTE);
          } else {
            // history(AGENCY_DASHBOARD_ROUTE);
          }
        }
      }
    } catch (error) {
      if (error.response) {
        const { data } = error.response;
        CustomAlertMessage(data.message, "error", enqueueSnackbar);
      }
    } finally {
      setLoading(false);
    }
  };
  const getAllAgency = async () => {
    const config = {
      method: "POST",
      url: ALL_AGENCY_LIST,
      // headers: authHeader(),
      data: {
        count: 10,
        offset: 0,
        agencyName: "",
        email: values.email,
      },
    };
    const response = await API(config);
    const {  data } = response.data;
    setList(data);
  };
  const VerifyFun = async () => {
    getAllAgency();

    if (values.email !== "" && values.password !== "") {
      const config = {
        method: "POST",
        url: LOGIN_URL,
        data: {
          ...values,
          userRole: role,
          agencyId: values.agencyId,
          isFirstLogin: true,
        },
      };
      try {
        setLoadingVerify(true);
        const response = await API(config);
        const { status, isAdmin, isAgency } = response.data;
        if (status === "Success") {
          setAuthFlag(true);
          setIsAdmin(isAdmin);
          setIsAgency(isAgency);
        }
      } catch (error) {
        console.error(error);
        if (error.response) {
          const { data } = error.response;
          CustomAlertMessage(data.message, "error", enqueueSnackbar);
        }
      } finally {
        setLoadingVerify(false);
      }
    }
  };
  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .trim()
      .email("Invalid email")
      .required("Email Required"),
    password: Yup.string().required("Password Required"),
  });

  const { handleSubmit, handleChange, values, handleBlur, errors, touched } =
    useFormik({
      initialValues: {
        email: "",
        password: "",
        agencyId: "",
      },
      validationSchema,
      onSubmit: (values) => LogIn(values),
    });
  const backToSigin = () => {
    setAuthFlag(false);
  };
  return (
    <div>
      <Container fluid>
        <Row>
          <Col md="5" lg="6" className="loginBg-end">
            <img alt="Logo" src={loginBg} className="w-100" />
          </Col>
          {!PassFlag ? (
            <Col md="6" className="d-flex">
              <ResetPassword token={token} UserData={UserData} />
            </Col>
          ) : (
            <></>
          )}
          {authFlag === false ? (
            PassFlag ? (
              <Col md="7" lg="6" className="d-flex">
                <div className="login-form">
                  <img alt="Logo" className="logo" src={logo} />
                  <h4>Sign in</h4>
                  <p className="mb-4">
                    Enter your email and password to login our dashboard
                  </p>

                  <Form>
                    <FormGroup>
                      <Label for="exampleEmail">Email</Label>
                      <Input
                        type="email"
                        onBlur={handleBlur}
                        name="email"
                        values={values.email}
                        invalid={touched.email && errors.email ? true : false}
                        onChange={handleChange}
                        id="exampleEmail"
                        placeholder="Enter your email"
                      />
                      <FormFeedback>
                        {touched.email && errors.email ? errors.email : ""}
                      </FormFeedback>
                    </FormGroup>

                    <FormGroup>
                      <Label for="exampleEmail">Password</Label>
                      <InputGroup>
                        <Input
                          type={passwordShown ? "text" : "password"}
                          onBlur={handleBlur}
                          name="password"
                          values={values.passsword}
                          invalid={
                            touched.password && errors.password ? true : false
                          }
                          onChange={handleChange}
                          id="exampleEmail"
                          placeholder="Enter your passsword"
                        />
                        <>
                          <InputGroupText
                            onClick={togglePassword}
                            style={{ cursor: "pointer" }}
                          >
                            {passwordShown ? (
                              <img src={Iconawesomeeye} alt=""/>
                            ) : (
                              <img src={Iconionicmdeyeoff} alt=""/>
                            )}
                          </InputGroupText>
                        </>
                        <FormFeedback>
                          {touched.password && errors.password
                            ? errors.password
                            : ""}
                        </FormFeedback>
                      </InputGroup>
                    </FormGroup>
                    {/* 1st submit */}
                    <Button color="primary" block onClick={VerifyFun}>
                      {loadingVerify && <CustomButtonLoader />} SIGN IN
                    </Button>
                    <Link to={FORGET_PASSWORD}>Forgot Password?</Link>
                  </Form>
                </div>
              </Col>
            ) : (
              <Col md="6" className="d-flex">
                <ResetPassword token={token} UserData={UserData} />
              </Col>
            )
          ) : (
            <Col md="7" lg="6" className="d-flex">
              <div className="login-form">
                {PassFlag ? (
                  <img alt="Logo" className="logo" src={logo} />
                ) : (
                  <></>
                )}
                {isAdmin && PassFlag ? (
                  <>
                    <Button color="primary" block onClick={handleSubmit}>
                      {loading && <CustomButtonLoader />} Login to the admin
                      portal
                    </Button>
                    <br />
                  </>
                ) : (
                  <></>
                )}
                {isAdmin && isAgency && PassFlag ? (
                  <div
                    style={{
                      position: "relative",
                      width: "100%",
                    }}
                  >
                    <hr
                      style={{ width: "100%", border: "1px solid #c8c0c0" }}
                    />
                    <p
                      style={{
                        position: "absolute",
                        left: "0",
                        right: "0",
                        textAlign: "center",
                        top: "-11px",
                      }}
                    >
                      <span
                        style={{
                          backgroundColor: "#f9f9f9",
                          padding: "5px 10px",
                        }}
                      >
                        Or
                      </span>
                    </p>
                  </div>
                ) : (
                  <></>
                )}
                {/* <br /> */}
                {isAgency && PassFlag ? (
                  <Form>
                    <FormGroup>
                      <Label for="exampleEmail">Agency</Label>
                      <Input
                        type="select"
                        onBlur={handleBlur}
                        name="agencyId"
                        values={values.agencyId}
                        invalid={
                          touched.agencyId && errors.agencyId ? true : false
                        }
                        onChange={handleChange}
                        id="exampleEmail"
                        placeholder="Select your agency"
                      >
                        <option value="">Select your Agency</option>
                        {list &&
                          list.map((i) => (
                            <option key={i.agencyId} value={i.agencyId}>
                              {i.agencyName}
                            </option>
                          ))}
                      </Input>
                      <FormFeedback>
                        {touched.agencyId && errors.agencyId
                          ? errors.agencyId
                          : ""}
                      </FormFeedback>
                    </FormGroup>

                    <Button color="primary" block onClick={logSig}>
                      {loadingAuth && <CustomButtonLoader />} SIGN IN
                    </Button>
                  </Form>
                ) : (
                  <></>
                )}
                {/* <br /> */}
                {PassFlag ? (
                  <div className="top-btn" style={{ textAlign: "center" }}>
                    <img
                    alt=""
                      src={BackArrow}
                      style={{
                        marginRight: "1px !important",
                        marginTop: "-1px !important",
                      }}
                    />

                    <Button
                      color="primary"
                      style={{
                        backgroundColor: "#f9f9f9",
                        borderColor: "#f9f9f9",
                        color: "#000",
                      }}
                      onClick={backToSigin}
                    >
                      Back
                    </Button>
                  </div>
                ) : (
                  <></>
                )}{" "}
              </div>
            </Col>
          )}
        </Row>
      </Container>
    </div>
  );
}
